export class AddressUpdateModel {
  constructor(
    public confirmed: boolean,
    public failReasonCode: string,
  ) {
  }
}
